export var FireblocksGeneralSubstatus;
(function (FireblocksGeneralSubstatus) {
    FireblocksGeneralSubstatus["INTERNAL_ERROR"] = "INTERNAL_ERROR";
})(FireblocksGeneralSubstatus || (FireblocksGeneralSubstatus = {}));
//# sourceMappingURL=fireblocks-general-substatus.enum.js.map